import { CacheId, useCache } from './useCache';

export enum SortDirection {
  ASC = 1,
  DESC = -1,
}

export type PaginateParams = {
  take?: number;
  skip?: number;
};

export function useQuery<QueryResponse>(
  cacheId: CacheId,
  query: () => Promise<QueryResponse>
): { result: Promise<QueryResponse> } {
  const { getCached, setCache } = useCache<Promise<QueryResponse>>();
  const cacheValued = getCached(cacheId);

  if (cacheValued !== undefined) {
    return { result: Promise.resolve(cacheValued) };
  }

  const value = query();

  setCache(cacheId, value);

  return { result: value };
}
